<script setup lang="ts">
</script>

<template>
  <router-view></router-view>
</template>

<style scoped>
* {
  margin: 0; padding: 0; box-sizing: border-box;
}
body, html {
  height: 100%;
  width: 100%;margin: 0;
  touch-action: manipulation;
}
</style>
